import { ReactElement, ReactNode } from 'react';

import { IconButton as ButtonIcon, Tooltip } from '@material-ui/core';

import classNames from 'classnames';

import { useStyles } from './styles';
import { MenuId } from './useMenuState';

type ToolbarDropdownProps = {
  id: MenuId;
  label: string;
  icon: ReactElement;
  openMenu: MenuId | null;
  onToggle: (id: MenuId) => void;
  children: ReactNode;
};

export const ToolbarDropdown = ({
  id,
  label,
  icon,
  openMenu,
  onToggle,
  children,
}: ToolbarDropdownProps) => {
  const classes = useStyles();

  return (
    <div className={classes.menuContainer}>
      <Tooltip title={label}>
        <ButtonIcon
          size="small"
          aria-label={label}
          onClick={() => onToggle(id)}
          className={classNames(classes.button, {
            [classes.buttonActive]: openMenu === id,
          })}
        >
          {icon}
        </ButtonIcon>
      </Tooltip>
      {openMenu === id && <div className={classes.popover}>{children}</div>}
    </div>
  );
};
